import React, { forwardRef } from 'react';
import cx from 'classnames';
import { VisuallyHidden } from '../__primitives__/VisuallyHidden';
import { LoadingIndicator } from '../LoadingIndicator';
import { resolveButtonIcon } from './Button.helpers';
import { useButton } from './useButton';
import styles from './Button.module.scss';
export const Button = forwardRef(({ as: ButtonElement = 'button', fullWidth = false, icon, label = '', loading = false, reverse = false, showLabel = true, size = 'medium', variant = 'primary', ...props }, ref) => {
    const { buttonProps } = useButton({
        ...props,
        as: ButtonElement,
    });
    const IconComponent = resolveButtonIcon(icon);
    const iconClassName = typeof icon === 'string' ? icon : '';
    if (!label && IconComponent) {
        throw new Error('Button must have discernible text. Even when using icon-only button (showLabel = false), you must still pass a label');
    }
    return (<ButtonElement ref={ref} {...buttonProps} className={cx(styles.button, styles[size], styles[variant], {
            [styles.reverse]: reverse,
            [styles.fullWidth]: fullWidth,
            [styles.iconButton]: !showLabel,
        })}>
					{loading ? (<span className={styles.icon}>
							<LoadingIndicator showText={false}/>
						</span>) : (<>
							{showLabel ? <span className={styles.label}>{label}</span> : <VisuallyHidden>{label}</VisuallyHidden>}
							{IconComponent && (<span className={cx(styles.icon, styles[iconClassName], {
                    [styles.autoFlip]: icon === 'chevron' || icon === 'arrow',
                })}>
									<IconComponent />
								</span>)}
						</>)}
				</ButtonElement>);
});
Button.displayName = 'Button';
